<p-dialog
  header="Перевірка ціни виробничого повернення"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [style]="{'width': '720px', 'max-height': '80vh'}"
  (onHide)="onHide()">

  <p-progressSpinner *ngIf="loading" styleClass="manufacturing-backdoc-price-check-dialog__spinner" strokeWidth="6"></p-progressSpinner>

  <div *ngIf="!loading && error" class="manufacturing-backdoc-price-check-dialog__error">
    Не вдалося завантажити перерахунок ціни. Спробуйте пізніше.
  </div>

  <div *ngIf="!loading && !error && !summary" class="manufacturing-backdoc-price-check-dialog__empty">
    Немає даних для цього рядка.
  </div>

  <ng-container *ngIf="!loading && !error && summary">

    <div *ngIf="unconfirmedReason" class="manufacturing-backdoc-price-check-dialog__unconfirmed">
      Збіг не підтверджено: {{unconfirmedReason}}
    </div>

    <div *ngIf="!unconfirmedReason && breakdownRows.length === 0" class="manufacturing-backdoc-price-check-dialog__empty">
      Не знайдено документів передачі на виробництво, що формують цю ціну.
    </div>

    <p-table *ngIf="breakdownRows.length > 0" [value]="breakdownRows" styleClass="p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>Документ передачі</th>
          <th>Дата</th>
          <th style="text-align: right">Сума (валюта документа)</th>
          <th style="text-align: right">Курс</th>
          <th style="text-align: center">PRIMDOCID</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{row.ForwardDocNumber}}</td>
          <td>{{row.ForwardDocDate | date:'dd.MM.yyyy'}}</td>
          <td style="text-align: right">{{row.ContributionCurrency | number:'1.2-2'}}</td>
          <td style="text-align: right">{{row.DOCRATEVAL | number:'1.4-4'}}</td>
          <td style="text-align: center">
            <span *ngIf="row.PrimDocIdMatch" class="manufacturing-backdoc-price-check-dialog__match-note">так</span>
            <span *ngIf="!row.PrimDocIdMatch" class="manufacturing-backdoc-price-check-dialog__mismatch-note">ні</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr class="manufacturing-backdoc-price-check-dialog__totals">
          <td colspan="2">Разом</td>
          <td style="text-align: right">{{totalContributionCurrency | number:'1.2-2'}}</td>
          <td colspan="2"></td>
        </tr>
      </ng-template>
    </p-table>

    <div class="manufacturing-backdoc-price-check-dialog__compare">
      <div>
        Ціна в документі (валюта документа): <strong>{{summary.StoredUnitPriceCurrency | number:'1.2-2'}}</strong>
        (перерахована: {{summary.RecomputedUnitPriceCurrency | number:'1.2-2'}})
      </div>
      <div>
        Ціна в документі (основна валюта): <strong>{{summary.StoredUnitPriceMain | number:'1.2-2'}}</strong>
        (перерахована: <span [class.manufacturing-backdoc-price-check-dialog__mismatch]="isMismatch">{{summary.RecomputedUnitPriceMain | number:'1.2-2'}}</span>)
        <span *ngIf="isMismatch" class="manufacturing-backdoc-price-check-dialog__mismatch-note">
          — не збігається зі збереженою ціною
        </span>
        <span *ngIf="!isMismatch" class="manufacturing-backdoc-price-check-dialog__match-note">
          — збігається
        </span>
      </div>
      <div class="manufacturing-backdoc-price-check-dialog__bom" *ngIf="summary.BOMPartCount > 0">
        Специфікація (BOM): {{summary.BOMPartCount}} позицій,
        <span [class.manufacturing-backdoc-price-check-dialog__mismatch]="summary.BOMMismatchedPartCount > 0">
          {{summary.BOMMismatchedPartCount}} з розбіжністю
        </span>
        <ng-container *ngIf="summary.BOMMismatchedPartCount > 0">
          (сумарне відхилення кількості: {{summary.BOMTotalQtyDiscrepancy | number:'1.0-2'}})
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-template pTemplate="footer">
    <p-button label="Застосувати виправлення" [disabled]="!canApply" severity="warning" (onClick)="onApplyClick()"></p-button>
    <p-button label="Закрити" [text]="true" severity="primary" (onClick)="onHide()"></p-button>
  </ng-template>
</p-dialog>
